import {useNavigation} from '@react-navigation/native';
import * as React from 'react';
import {Platform, View} from 'react-native';
import {ProductsPriceFilterViewBaseProps} from '../../../model';
import {useStyles} from '../../../../../../shared/hooks/styles';
import {DeviceSize} from '../../../../../../shared/theme/helpers';
import {ProductPriceFilterList} from '../../list';
import {Text} from '../../../../../../shared/components/text';

export const ProductsPriceFilterMobile: React.FC<ProductsPriceFilterViewBaseProps> = ({productPrices, onSubmit}) => {
  const navigation = useNavigation();

  const _handlePressShow = () => {
    onSubmit();
    Platform.OS !== 'web' && navigation.goBack();
  };

  const styles = useStyles(({theme, mediaOnly}) => ({
    container: {
      flexDirection: 'column',
      justifyContent: 'flex-start',
      alignItems: 'stretch',
      paddingTop: Platform.OS === 'web' ? 35 : 0,
      paddingHorizontal: 35,
    },
    filterButtonContainer: {
      marginTop: 5,
      paddingVertical: 12,
      paddingHorizontal: 0,
      justifyContent: 'center',
      alignItems: 'center',
      borderTopWidth: Platform.OS === 'web' ? 1 : 0,
      borderStyle: 'solid',
      borderTopColor: theme.color.borderColor,
    },
    filterButton: mediaOnly(DeviceSize.mobile, {width: '100%'}, {width: 328}),
  }));

  return (
    <View style={styles.container}>
      <View style={{marginBottom: 25, alignSelf: 'center'}}>
        <Text type='h4'>Стоимость в баллах</Text>
      </View>
      <ProductPriceFilterList productPrices={productPrices} />
      <View style={[styles.filterButtonContainer]} />
    </View>
  );
};
